import { Component, EventEmitter, Input, Output } from '@angular/core';
import { noteIconsMap } from './user-note-alert.constants';
import { Router } from '@angular/router';
import { ToastLink } from 'src/app/pages/custom-toast/toast-interfaces';

@Component({
  selector: 'app-user-note-alert',
  templateUrl: './user-note-alert.component.html',
  styleUrls: ['./user-note-alert.component.scss'],
})
export class UserNoteAlertComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() type: 'info' | 'success' | 'warning' | 'danger' = 'info';
  @Input() additionalNotes = []; //Each entry of this will be displayed
  @Input() showNotesAsList: boolean = true;
  @Input() customClass: string = '';
  @Input() links: ToastLink[] = [];
  @Output() linkClicked: EventEmitter<any> = new EventEmitter<any>();
  icon = noteIconsMap[this.type];

  constructor(private router: Router) {}

  onLinkClick(link, index) {
    if (link?.url) {
      this.router.navigate([link?.url]);
    }
    this.linkClicked.emit(link);
  }
}
